export default __webpack_public_path__ + "static/media/b1.c881e64a.webp";